<script>
	const moment = require('moment');

	module.exports = {
		data() {
			return {
				classCode: null,
				startDate: null,
				name: null
			};
		},
		mounted() {
			this.$subscribe('modal-opened', (modalId, opts) => {
				if (modalId !== 'modal-survey-confirm') {
					return true;
				}

				// Need email and password to retry login route
				if (opts.classCode && opts.startDate && opts.name) {
					this.classCode = opts.classCode;
					this.startDate = moment(opts.startDate || new Date().setHours(0, 0, 0, 0)).format('M/D/YYYY');
					this.name = opts.name;
				}
				return false;
			});
		}
	};
</script>
<template>
	<modal
		ref="modal"
		id="modal-survey-confirm">
		<template slot="header-container">
			<h2>Scheduled</h2>
			<p>Vocabulary Quest<sup>beta</sup></p>
		</template>
		<div slot="content">
			<p><strong>Scheduled for:</strong> {{ name }}</p>
			<p><strong>Date:</strong> {{ startDate }}</p>
			<p>Please note:</p>
			<ul>
				<li>Please note: Neither you nor your students will be able to see immediate results. ReadWorks staff will share results with you.</li>
			</ul>
			<p class="text-centered">
				<a
					:href="'/assignments#!classCode:' + classCode"
					class="button">
					Go to Assignments
				</a>
			</p>
			<p class="text-centered">
				<a
					data-modal-close
					class="button -small -outline">
					Close
				</a>
			</p>
		</div>
	</modal>
</template>
